import { render } from "./CreateSpecialPaymentRequestNoPO.vue?vue&type=template&id=54f4c0a4&scoped=true"
import script from "./CreateSpecialPaymentRequestNoPO.vue?vue&type=script&lang=ts"
export * from "./CreateSpecialPaymentRequestNoPO.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-54f4c0a4"

export default script